<template>
    <div v-if="quantity && !quantity.isHidden" class="s-purchasing-quantity">
        <p v-if="quantity.title" class="title" v-html="quantity.title" />
        <div class="wrapper">
            <ANumberInput
                :step="quantity.step || 1"
                :quantity="value"
                :min="quantity.min || 0"
                :max="quantity.max || value + quantity.step"
                @change="$emit('change', $event)"
            />
            <template v-if="price">
                <div>×</div>
                <div class="price">
                    <div v-if="discount" class="price-full" v-html="discount" />
                    <div class="price-current" v-html="price" />
                </div>
            </template>
        </div>
        <p v-if="quantity.description" class="description" v-html="quantity.description" />
    </div>
</template>

<script>
import ANumberInput from '@core/slices/pages/purchasing-cyber-protect/version-2/components/num-picker.vue';

export default {
    name: 'SPurchasingQuantity',

    components: {
        ANumberInput,
    },

    props: {
        value: {
            type: Number,
            default: 0,
        },
        quantity: {
            type: Object,
            default: null,
        },
        price: {
            type: String,
            default: null,
        },
        discount: {
            type: String,
            default: null,
        },
    },

    emits: ['change'],
};
</script>

<style lang="postcss" scoped>
.s-purchasing-quantity {
    .wrapper {
        gap: 8px;
        height: 48px;
        display: flex;
        margin-top: 16px;
        user-select: none;
        align-items: center;
         &:deep(.number-wrapper) {
            background: #fff;
            .number-input {
                height: 48px;
                .decrement,
                .increment {
                    width: 36px;
                    border: none;
                    background: transparent;
                    .a-glyph {
                        width: 16px;
                        height: 16px;
                        max-width: unset;
                        max-height: unset;
                    }
                }
                input {
                    @mixin lead;
                    width: auto;
                    min-width: 38px;
                    color: var(--av-nav-primary);
                }
            }
        }
    }
    .title {
        @mixin paragraph-accent;
        margin-bottom: 16px;
        text-transform: capitalize;
        color: var(--av-nav-primary);
    }
    .description {
        @mixin descriptor;
        margin-top: 16px;
        color: var(--av-nav-primary);
    }
    .price {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        color: var(--av-nav-primary);
        @media (--viewport-desktop-large) {
            flex-direction: row;
            align-items: center;
        }
    }
    .price-full {
        @mixin caption;
        position: relative;
        text-decoration: none;
        color: var(--av-fixed-light);
        @media (--viewport-desktop-large) {
            margin-bottom: 0;
            margin-inline-end: 8px;
        }
        &:before {
            inset-inline-start: 0;
            top: 50%;
            height: 1px;
            content: "";
            width: 100%;
            position: absolute;
            background: var(--av-fixed-light);
        }
    }
    .price-current {
        @mixin title-accent;
    }
}
</style>
